import { Component, Renderer2, ViewChild, viewChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { InventoryService } from "src/app/service/inventory.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  FormControl,
  AbstractControl,
} from "@angular/forms";
import { CrmService } from "src/app/service/crm.service";
import { NgClass } from "@angular/common";
import {
  MatAutocomplete,
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { ForwardServiceReqComponent } from "../shared/forward-service-req/forward-service-req.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NoDataComponent } from "../shared/no-data/no-data.component";
import { ActivatedRoute, Router } from "@angular/router";
import {
  alertModalDecline,
  alertModalDelete,
  alertModalWithoutConfirm,
} from "../../helpers/alert";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { environment } from "src/environments/environment";

interface Urgency {
  value: string;
  viewValue: string;
}

interface Service {
  value: string;
  viewValue: string;
}

interface Damage {
  value: string;
  viewValue: string;
}

interface Request {
  value: string;
  viewValue: string;
}
interface AllServicesReq {
  value: string;
  viewValue: string;
}
interface PendingServicesReq {
  value: string;
  viewValue: string;
}
interface ApprovedServicesReq {
  value: string;
  viewValue: string;
}

interface DeclinedServicesReq {
  value: string;
  viewValue: string;
}

import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { INVENTORY_APPROVER_DEPARTMENTS, isHrOrItAdminDept } from 'src/app/constants/departments';
@Component({
    selector: "app-service-request",
    providers: [provideNativeDateAdapter()],
    imports: [
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        MatInputModule,
        MatAutocompleteModule,
        ForwardServiceReqComponent,
        NoDataComponent,
        InfiniteScrollModule,
    ],
    templateUrl: "./service-request.component.html",
    styleUrls: ["./service-request.component.css", "../styles/inventory.css"]
})
export class ServiceRequestComponent {
  /** HR, HR-HEAD, or IT-ADMIN: the same buttons and approver lists. */
  get isHrUser(): boolean {
    return isHrOrItAdminDept(this.userDepartment);
  }
  showNoDataMessage: boolean = false;
  isFormSubmitting: boolean = false;
  @ViewChild("auto") auto: MatAutocomplete;
  //Select Field Options
  urgencies: Urgency[] = [
    { value: "High", viewValue: "High" },
    { value: "Medium", viewValue: "Medium" },
    { value: "Low", viewValue: "Low" },
  ];

  services: Service[] = [
    { value: "Repair", viewValue: "Repair" },
    { value: "Replaced", viewValue: "Replaced" },
    { value: "Damage", viewValue: "Damage" },
  ];

  damages: Damage[] = [{ value: "Screen-Broken", viewValue: "Screen Broken" }];

  requests: Request[] = [
    { value: "Service Request", viewValue: "Forwarded Request" },
  ];

  allServiceReq: AllServicesReq[] = [
    { value: "Service Request", viewValue: "Service Request" },
  ];

  pendingServiceReq: PendingServicesReq[] = [
    { value: "Service Request", viewValue: "Pending Request" },
  ];
  approvedServiceReq: ApprovedServicesReq[] = [
    { value: "Service Request", viewValue: "Approved Request" },
  ];

  declinedServiceReq: DeclinedServicesReq[] = [
    { value: "Rejected", viewValue: "Declined Request" },
  ];

  isShimmerLoading: boolean = true;
  shimmerLoadingValue = ([] = [1, 2, 3, 4, 5]);

  pendingReq = [];
  totalPending: any;
  selectedRequestType: any;
  currentPendingLimit = 1000;
  onFilterPendingRequest(
    requestType: string,
    pageNum: number = this.currentPageNume,
    limit: number = this.currentLimit
  ) {
    const getPendingReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentPendingLimit,
    };

    this.inventoryService
      .getPendingRequest(getPendingReqValue)
      .subscribe((response) => {
        console.log("Pending Request");

        if (pageNum === 1) {
          this.pendingReq = response["data"].records;
        } else {
          this.pendingReq = [...this.pendingReq, ...response["data"].records];
          console.log(
            "Fetching Page:",
            this.currentPageNume,
            "Limit:",
            this.currentPendingLimit
          );
        }

        this.totalPending = response["data"].totalCounts;
        this.showForwardedReqTable = false;
        this.showServiceRequestTable = false;
        this.showApprovedRequest = false;
        this.showPendingRequest = true;
        this.showDeclinedRequest = false;
      });
  }

  pendingSearchQuery: any;
  searchedPendingInventory = [];
  totalPendingSearchedInv: any;
  onSearchPendingInventory() {
    const getPendingReqValue: any = {
      requestType: "Service Request",
      searchQuery: this.pendingSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalPending,
    };

    if (!this.pendingSearchQuery || this.pendingSearchQuery.trim() === "") {
      this.clearPendingSearch();
    } else {
      this.inventoryService
        .getPendingRequest(getPendingReqValue)
        .subscribe((response) => {
          console.log("Search Pending Response", response);
          this.searchedPendingInventory = response["data"].records;
          this.pendingReq = this.searchedPendingInventory;
          this.totalPendingSearchedInv = response["data"].totalCounts;
          this.totalPending = this.totalPendingSearchedInv;
        });
    }
  }

  clearPendingSearch() {
    this.pendingSearchQuery = "";
    this.onFilterPendingRequest("Service Request", 1, this.currentPendingLimit);
  }

  totalApprovedSearchedInv: any;
  searchedApprovedInventory = [];

  onSearchApprovedInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalApproved,
    };

    const getApprovedReqValue: any = {
      requestType: "Service Request",
      searchQuery: this.approvedSearchQuery,
    };
          if (this.showForwardButton) {
    getApprovedReqValue.isAll = "true";
  }

    if (!this.approvedSearchQuery || this.approvedSearchQuery.trim() === "") {
      this.clearApprovedSearch();
    } else {
      this.inventoryService
        .getApprovedRequest(getApprovedReqValue)
        .subscribe((response) => {
          console.log("Search Approved Response", response);
          this.searchedApprovedInventory = response["data"].records;
          this.approveInv = this.searchedApprovedInventory;
          this.totalApprovedSearchedInv = response["data"].totalCounts;
          this.totalApproved = this.totalApprovedSearchedInv;
        });
    }
  }

  clearApprovedSearch() {
    this.approvedSearchQuery = "";
    this.onFilterApprovedRequest("Service Request", 1, this.currentLimit);
  }

  approveInv = [];
  totalApproved: any;
  approvedSearchQuery: any;
  currentApprovedLimit = 1000;
  onFilterApprovedRequest(
    requestType: string,
    pageNum: number = this.currentPageNume,
    limit: number = this.currentApprovedLimit
  ) {
    const getApprovedReqValue: any = {
      requestType: requestType,
      pageNum: pageNum,
      limit: limit,
      searchQuery: this.approvedSearchQuery,
    };
    const field: any = {};
          if (this.showForwardButton) {
    getApprovedReqValue.isAll = "true";
  }

    this.inventoryService
      .getApprovedRequest(getApprovedReqValue)
      .subscribe((response) => {
        console.log("Approved Request", response);

        if (pageNum === 1) {
          this.approveInv = response["data"].records;
        } else {
          this.approveInv = [...this.approveInv, ...response["data"].records]; // next pages
        }

        this.totalApproved = response["data"].totalCounts;

        this.showForwardedReqTable = false;
        this.showServiceRequestTable = false;
        this.showApprovedRequest = true;
        this.showPendingRequest = false;
        this.showDeclinedRequest = false;
      });
  }

  declineInv = [];
  totalDeclined: any;
  currentDeclinedLimit = 1000;
  onFilterDeclinedRequest(
    status: string = "Rejected",
    pageNum: number = this.currentPageNume,
    limit: number = this.currentDeclinedLimit
  ) {
    const field: any = {
      pageNum: pageNum,
      limit: limit,
      status: status,
    };
    this.inventoryService.getServiceRequest(field).subscribe((response) => {
      console.log("Declined Request", response);

      if (pageNum === 1) {
        this.declineInv = response["data"].records;
      } else {
        this.declineInv = [...this.declineInv, ...response["data"].records];
      }
      this.totalDeclined = response["data"].totalCounts;
      this.showForwardedReqTable = false;
      this.showServiceRequestTable = false;
      this.showApprovedRequest = false;
      this.showPendingRequest = false;
      this.showDeclinedRequest = true;
    });
  }

  declinedSearchQuery: any;
  searchedDeclinedInventory = [];
  totalDeclinedSearchedInv: any;

  onSearchDeclinedInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalDeclined,
      searchQuery: this.declinedSearchQuery,
      status: "Rejected",
    };

    if (!this.declinedSearchQuery || this.declinedSearchQuery.trim() === "") {
      this.clearDeclinedSearch();
    } else {
      this.inventoryService.getServiceRequest(field).subscribe((response) => {
        console.log("Search Declined Response", response);
        this.searchedDeclinedInventory = response["data"].records;
        this.declineInv = this.searchedDeclinedInventory;
        this.totalDeclinedSearchedInv = response["data"].totalCounts;
        this.totalDeclined = this.totalDeclinedSearchedInv;
      });
    }
  }

  clearDeclinedSearch() {
    this.declinedSearchQuery = "";
    this.onFilterDeclinedRequest("Rejected", 1, this.currentDeclinedLimit);
  }

  serviceRequestForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private inventoryService: InventoryService,
    private crmService: CrmService,
    private snackBar: MatSnackBar,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private router: Router
  ) {
    // Service Request Form Group
    this.serviceRequestForm = this.fb.group({
      damageType: [
        "",
        [
          Validators.required,
          Validators.maxLength(100),
          this.noWhitespaceValidator,
        ],
      ],
      serviceType: ["", Validators.required],
      needByDate: ["", Validators.required],
      detail: [
        "",
        [
          Validators.maxLength(200), 
        ],
      ],
      urgency: ["", Validators.required],
      approverName: [""],
      assignedInventoryId: [null, Validators.required],
      maximumCost: [
        "0",
        this.showForwardButton
          ? [Validators.required, this.noWhitespaceValidator]
          : [],
      ],
      comment: [
        "",
        this.showForwardButton
          ? [Validators.required, this.noWhitespaceValidator]
          : [],
      ],
    });
  }

  // Price Formatting
  formatCurrency(value: string | number): string {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(String(value).replace(/,/g, ""));
    return isNaN(num) ? "" : new Intl.NumberFormat("en-IN").format(num);
  }

  onProductCostInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    const plainValue = input.value.replace(/,/g, "");

    if (!plainValue || isNaN(Number(plainValue))) {
      this.serviceRequestForm
        .get("maximumCost")
        ?.setValue(plainValue, { emitEvent: false });
      return;
    }

    const formatted = this.formatCurrency(plainValue);
    this.serviceRequestForm
      .get("maximumCost")
      ?.setValue(plainValue, { emitEvent: false });
    input.value = formatted;
  }

  blockNonNumeric(event: KeyboardEvent): void {
    const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
    if (!/[0-9]/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  noWhitespaceValidator(
    control: AbstractControl
  ): { [key: string]: any } | null {
    const isWhitespace = (control.value || "").trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }

  userDepartment: string;
  showForwardButton = false;
  productIdFromQuery: string;
  today: string;
  showForwardFilter = false;
  loogedUserId: any;
  selectedFilter: string = "";

  ngOnInit() {
    //to disable the past dates
    const now = new Date();
    this.today = now.toISOString().split("T")[0];

    this.route.queryParams.subscribe((params) => {
      const filter = params["filter"];
      if (filter) {
        this.selectedFilter = filter;
        this.applyFilterFromQuery(filter);
      }
    });

    this.getAssignedInventoryData();
    // this.getAllUsers();
    this.getInventoryData();
    this.getServiceRequestData();
    this.getApproverUsersList();
    this.loogedUserId = localStorage.getItem("guestID");
    this.userDepartment = localStorage.getItem("department");
    this.showForwardButton = isHrOrItAdminDept(this.userDepartment);
    this.showForwardFilter =
      isHrOrItAdminDept(this.userDepartment) || this.userDepartment === "ADMIN";

    this.route.queryParams.subscribe((params) => {
      if (params["productId"]) {
        this.productIdFromQuery = params["productId"];
        this.serviceRequestForm.patchValue({
          selectedInventory: this.productIdFromQuery,
        });

        console.log("All inventories:", [
          ...this.inventory,
          ...this.trueInventory,
        ]);

        setTimeout(() => {
          const combinedInventory = [...this.inventory, ...this.trueInventory];
          const existingInventory = combinedInventory.find(
            (item) => item.viewValue === this.productIdFromQuery
          );

          console.log("Did you find?", existingInventory);

          if (existingInventory) {
            console.log("Existing Inventory:", existingInventory);
            console.log(
              "Existing Inventory AssignedInventoryId:",
              existingInventory.assignedInventoryId
            );
            const updatedInventory = [
              existingInventory,
              ...combinedInventory.filter(
                (item) => item.viewValue !== this.productIdFromQuery
              ),
            ];
            this.inventory = updatedInventory;

            this.onInventoryChange({
              option: { value: existingInventory },
            } as MatAutocompleteSelectedEvent);

            // console.log('Before patching assignedInventoryId:', this.serviceRequestForm.value.assignedInventoryId);

            this.serviceRequestForm.patchValue({
              assignedInventoryId: existingInventory.assignedInventoryId,
            });

            console.log(
              "After patching assignedInventoryId:",
              this.serviceRequestForm.value.assignedInventoryId
            );
            console.log({
              assignedInventoryId:
                this.serviceRequestForm.value.assignedInventoryId,
            });
          } else {
            console.warn(
              "Inventory not found for productId:",
              this.productIdFromQuery
            );
          }
          this.auto.options.first?.select();
          this.selectedInventoryControl.setValue({
            viewValue: this.productIdFromQuery,
          });
        }, 1000);
      }

      if (params["openServiceReq"] === "true") {
        this.openServiceRequestModal();
      }

      this.route.queryParams.subscribe((params) => {
      const filter = params["filter"];
      if (filter) {
        this.selectedFilter = filter;
        this.applyFilterFromQuery(filter);
        setTimeout(() => this.selectedFilter = filter, 0);
      }
    });
    });

    //   if (!this.showForwardButton) {
    //   this.serviceRequestForm.get("maximumCost")?.clearValidators();
    //   this.serviceRequestForm.get("comment")?.clearValidators();
    //   this.serviceRequestForm.get("maximumCost")?.updateValueAndValidity();
    //   this.serviceRequestForm.get("comment")?.updateValueAndValidity();
    // }
  }

  applyFilterFromQuery(displayFilter: string) {
    const filterValue = this.filterTypeMap[displayFilter];

    this.selectedFilter = displayFilter;

    switch (displayFilter) {
      case "Approved Request":
        this.onFilterApprovedRequest(filterValue);
        break;
      case "Declined Request":
      case "Rejected":
        this.onFilterDeclinedRequest(filterValue);
        break;
      case "Forwarded Request":
        this.onRequestSelect(filterValue);
        break;
      default:
        console.warn("Unknown filter:", displayFilter);
    }
  }

  filterTypeMap: Record<string, string> = {
    "Approved Request": "Service Request",
    "Pending Request": "Service Request",
    "Forwarded Request": "Service Request",
    "Declined Request": "Rejected",
    Rejected: "Rejected",
  };

  openServiceRequestModal() {
    const modalElement = document.getElementById("serviceRequestModal");
    if (modalElement) {
      this.renderer.addClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "block");
    }
  }

  closeServiceRequestModal() {
    const modalElement = document.getElementById("serviceRequestModal");
    const backdrop = document.querySelector(".modal-backdrop");

    if (modalElement) {
      this.renderer.removeClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "none");
      this.renderer.setAttribute(modalElement, "aria-hidden", "true");
      this.renderer.removeClass(document.body, "modal-open");
      this.renderer.setStyle(document.body, "paddingRight", "");
    }

    if (backdrop) {
      this.renderer.removeChild(document.body, backdrop);
    }
    this.router.navigate(["/inventory/service-request"]);
  }

  showForwardedReqTable: boolean = false;
  showServiceRequestTable: boolean = true;
  showApprovedRequest: boolean = false;
  showPendingRequest: boolean = false;
  showDeclinedRequest: boolean = false;
  //On select Request Type
  onRequestSelect(value: string): void {
    this.currentPageNume = 1;
    this.serviceRequest = [];
    console.log("Selected value:", value);
    this.showForwardedReqTable = true;
    this.showServiceRequestTable = false;
    this.showApprovedRequest = false;
    this.showPendingRequest = false;
    this.showDeclinedRequest = false;
    this.filterForwardReq(value);
  }

  handleRequestForwarded(forwardedRequestId: string) {
    this.serviceRequest = this.serviceRequest.filter(
      (req) => req.requestId !== forwardedRequestId
    );
    this.totalService = this.serviceRequest.length;
  }

  openServiceForm() {
    this.serviceRequestForm.reset();
    this.formSubmitted = false;
    this.submitted = false;
    this.errorMessage = "";
    this.selectedInventoryControl.reset();
    this.searchQuery = "";
  }

  isForwarded = false;
  onForwardRequestSubmitted(): void {
    this.isForwarded = true;
  }

  //Filter Request Type
  forwardedReq = [];
  totalForwarded: any;
  currentRequestType: string = "";
  filterForwardReq(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    this.currentRequestType = requestType;

    const getForwardReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.inventoryService
      .getAllForwardedReq(getForwardReqValue)
      .subscribe((response) => {
        console.log("Forward Response", response);
        if (pageNum === 1) {
          this.forwardedReq = response["data"].records;
        } else {
          this.forwardedReq = [
            ...this.forwardedReq,
            ...response["data"].records,
          ];
        }
        // this.forwardedReq = response["data"].records;
        this.totalForwarded = response["data"].totalCounts;
        this.showForwardedReqTable = true;
        this.showServiceRequestTable = false;
      });
  }

  forwardedSearchQuery: any;
  searchedForwardedInventory = [];
  totalForwardedSearchedInv: any;
  onSearchForwardedInventory() {
    const getForwardReqValue: any = {
      requestType: this.currentRequestType || "Service Request",
      searchQuery: this.forwardedSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalForwarded,
    };

    if (!this.forwardedSearchQuery || this.forwardedSearchQuery.trim() === "") {
      this.clearForwardedSearch();
    } else {
      this.inventoryService
        .getAllForwardedReq(getForwardReqValue)
        .subscribe((response) => {
          console.log("Searched Forwarded Response", response);
          this.searchedForwardedInventory = response["data"].records;
          this.forwardedReq = this.searchedForwardedInventory;
          this.totalForwardedSearchedInv = response["data"].totalCounts;
          this.totalForwarded = this.totalForwardedSearchedInv;
        });
    }
  }

  clearForwardedSearch() {
    this.forwardedSearchQuery = "";
    this.filterForwardReq(
      this.currentRequestType || "Service Request",
      1,
      this.currentLimit
    );
  }

  //Date Format
  formatStartDate(date: Date): { day: number; month: number; year: number } {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }

  //Service Request Form submit
  formSubmitted = false;
  errorMessage = "";
  submitted: boolean = false;
  isSubmitting: boolean = false;
onServiceReqSubmit() {
  this.submitted = true;

  const serviceRequestValue = { ...this.serviceRequestForm.value };

  const needByDate = new Date(serviceRequestValue.needByDate);
  const formattedStartDate = this.formatStartDate(needByDate);

  const approver = (this.approverUsers && this.approverUsers.length > 0 ? this.approverUsers : [...this.adminUsers, ...this.hrUsers]).find(
    (user) => user?.value === serviceRequestValue?.approverName
  );
  const approverId = approver ? approver.id : null;

  const selectedInventoryAssetId = this.inventory.find(
    (item) =>
      item.assignedInventoryId === serviceRequestValue.assignedInventoryId
  )?.assetId;

  this.isSubmitting = true;

  const getserviceFormValue: any = {
    damageType: String(serviceRequestValue.damageType),
    serviceType: String(serviceRequestValue.serviceType),
    detail: String(serviceRequestValue.detail),
    needByDate: {
      day: needByDate.getDate(),
      month: needByDate.getMonth() + 1,
      year: needByDate.getFullYear(),
    },
    urgency: serviceRequestValue.urgency,
    approverName: String(serviceRequestValue.approverName || ""),
    assignedInventoryId: serviceRequestValue.assignedInventoryId,
    redirectUrl: `${environment.redirectUrl}#/inventory/service-request`,
 
  };
     if(this.showForwardButton){
      getserviceFormValue.redirectUrl = `${environment.redirectUrl}#/inventory/admin-request`
    }

  getserviceFormValue.maximumCost = String(
    serviceRequestValue.maximumCost || "0"
  );
  getserviceFormValue.comment = String(serviceRequestValue.comment || "");

  if (!this.showForwardButton) {
    // Non-HR users → approver required
    if (!approverId) {
      alertModalWithoutConfirm("warning", "Please select an approver.");
      this.isSubmitting = false;
      return;
    }
    getserviceFormValue.approverId = approverId;
  } else {
    // HR users → approver optional
    if (approverId) {
      getserviceFormValue.approverId = approverId;
    }
  }

  if (this.serviceRequestForm.invalid) {
    console.log("Form is invalid");
    this.isSubmitting = false;
    return alertModalWithoutConfirm(
      "warning",
      "Please fill in all required fields before submitting."
    );
  }

  this.errorMessage = null;
  this.isFormSubmitting = true;

  this.inventoryService.addServiceRequest(getserviceFormValue).subscribe(
    (response) => {
      console.log("submitted ", response);
      this.formSubmitted = true;
      this.isSubmitting = false;
      this.serviceRequestForm.reset();
      this.getServiceRequestData();
      this.showForwardedReqTable = false;
      this.showServiceRequestTable = true;
      this.errorMessage = null;
      this.isFormSubmitting = false;
    },
    (error) => {
      console.error("API Error", error);

      if (error?.error?.message?.message === "Request Already Active!") {
        this.errorMessage = "This request is already active.";
      } else {
        this.errorMessage = "Something went wrong. Please try again.";
      }
      this.isFormSubmitting = false;
      this.isSubmitting = false;
    }
  );
}


  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  //Listing of All Assigned Inventory in Dropdown
  inventory: any[] = [];
  getAssignedInventoryData() {
    const field: any = {
      pageNum: 1,
      limit: 500,
    };

    this.inventoryService.getAssignInv(field).subscribe(
      (response: any) => {
        this.inventory = response.data.records.reverse().map((item: any) => {
          const assetId = item.assetId || null;
          console.log("Assigned Inventory Data - assetId:", assetId);
          return {
            value: item.productId,
            // viewValue: item.assetData.productId,
            viewValue: item.assetData.name,
            assetImage: item.assetImage || [],
            assignedInventoryId: item.assignedInventoryId || null,
            assetId: assetId,
          };
        });
      },

      (error) => {
        console.error("Error", error);
      }
    );
  }

  trueInventory: any[] = [];
  getInventoryData() {
    const field: any = {
      pageNum: 1,
      limit: 500,
      available: true,
    };

    this.inventoryService.getAllInventory(field).subscribe(
      (response: any) => {
        this.trueInventory = response.data.records
          .reverse()
          .map((item: any) => ({
            value: item.productId,
            viewValue: item.productId,
            images: item.images || [],
            assetId: item.assetId || null,
          }));
      },

      (error) => {
        console.error("Error", error);
      }
    );
  }

  searchedInventory = [];
  totalSearchedInv: any;
  searchQuery: string;
  searchTimeout: any;

  onSearchInventory(event?: Event) {
    if (event) {
      event.preventDefault();
    }

    clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(() => {
      const trimmedQuery = this.searchQuery.trim().toLowerCase();

      if (trimmedQuery === "") {
        this.clearSearch();
        return;
      }

      const field: any = {
        pageNum: 1,
        limit: 100,
        searchQuery: trimmedQuery,
      };

      this.inventoryService.getSearchedServiceModalInventory(field).subscribe(
        (response: any) => {
          const keywords = trimmedQuery.split(/\s+/);

          this.searchedInventory = response.data.records
            .filter((item: any) => {
              const name = item.assetData?.name?.toLowerCase() || "";
              return keywords.every((keyword) => name.includes(keyword));
            })
            .map((item: any) => ({
              value: item.productId,
              viewValue: item.assetData.name,
              images: item.images || [],
              assetId: item.assetId || null,
            }));

          this.inventory = this.searchedInventory;
          this.totalSearchedInv = this.searchedInventory.length;
        },
        (error) => {
          console.error("Error fetching search results", error);
        }
      );
    }, 300);
  }

  clearSearch() {
    this.searchQuery = "";
    this.searchedInventory = [];
    this.inventory = [];
    this.totalSearchedInv = 0;
    this.getAssignedInventoryData();
  }

  // On select Asset Field
  selectedInventoryControl = new FormControl();
  onInventoryChange(event: MatAutocompleteSelectedEvent) {
    const selectedInventory = event.option.value;
    this.selectedInventoryControl.setValue(selectedInventory);

    // Update the form with additional data
    this.serviceRequestForm.patchValue({
      selectedInventory: selectedInventory.viewValue,
      assignedInventoryId: selectedInventory.assignedInventoryId,
    });

    console.log("Selected Inventory:", selectedInventory);
    console.log(
      "Selected AssignedInventoryId:",
      selectedInventory.assignedInventoryId
    );
  }

  displayFn(inventory: any): string {
    return inventory && inventory.viewValue ? inventory.viewValue : "";
  }

  // Approver Users (ADMIN, IT-ADMIN, HR-HEAD, HR)
  approverUsers: { value: string; viewValue: string; id: string; department?: string }[] = [];
  adminUsers: { value: string; viewValue: string; id: string }[] = [];
  hrUsers: { value: string; viewValue: string; id: string }[] = [];

  getApproverUsersList(): void {
    const approverDepts = INVENTORY_APPROVER_DEPARTMENTS;
    forkJoin(
      approverDepts.map((dept) =>
        this.crmService.getAnyUsers(dept).pipe(
          catchError((err) => {
            console.error(`Error fetching approvers for department ${dept}:`, err);
            return of({ data: [] });
          })
        )
      )
    ).subscribe((results: any[]) => {
      const userMap = new Map<string, { value: string; viewValue: string; id: string; department?: string }>();

      results.forEach((res, index) => {
        const expectedDept = approverDepts[index];
        const rawList = res?.data || res?.records || (Array.isArray(res) ? res : []);
        if (Array.isArray(rawList)) {
          rawList.forEach((user: any) => {
            const id = user?._id || user?.id;
            const userName = (user?.userName || user?.name || '').trim();
            const userDept = user?.department ? String(user.department).trim().toUpperCase() : expectedDept;
            if (id && userName && approverDepts.includes(userDept)) {
              if (!userMap.has(id)) {
                userMap.set(id, {
                  value: userName,
                  viewValue: userName,
                  id: id,
                  department: userDept,
                });
              }
            }
          });
        }
      });

      const sortedUsers = Array.from(userMap.values()).sort((a, b) =>
        a.viewValue.localeCompare(b.viewValue, undefined, { sensitivity: 'base' })
      );

      this.approverUsers = sortedUsers;
      this.adminUsers = sortedUsers;
      this.hrUsers = sortedUsers;
      console.log("Filtered approvers:", this.approverUsers);
    });
  }

  getAdminUsersList() {
    this.getApproverUsersList();
  }

  getHRUsersList() {
    this.getApproverUsersList();
  }

  //Listing of All service Request
  selectedInventory: any = {};
  serviceRequest = [];
  totalService: any;
  searchServiceReqQuery: string;
  currentPageNume = 1;
  currentLimit = 100;
  showActionHeader = false;

  getServiceRequestData() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      searchQuery: this.searchServiceReqQuery,
    };

    if (this.currentPageNume === 1) {
      this.serviceRequest = [];
    }

    this.inventoryService.getServiceRequest(field).subscribe((res: any) => {
      const newItems = res.data.records || [];
      if (this.currentPageNume === 1) {
        this.serviceRequest = [...newItems];
      } else {
        this.serviceRequest = [...this.serviceRequest, ...newItems];
      }

      this.showActionHeader = this.serviceRequest.some(
        (req) => req.requestedById === this.loogedUserId
      );

      const assetIds = this.serviceRequest
        .map((item: any) => item.assetId)
        .filter((assetId: any) => assetId !== null);

      this.totalService = res.data.totalCounts;
      this.showForwardedReqTable = false;
      this.showServiceRequestTable = true;
      this.showDeclinedRequest = false;
      this.showApprovedRequest = false;
      this.showPendingRequest = false;
      this.isShimmerLoading = false;
    });
  }

  async deleteInventoryRequest(requestId: any) {
    const userConfirmed = await alertModalDelete(
      "Are you sure you want to delete this request?"
    );
    if (userConfirmed) {
      const declineRequest = {
        action: "Rejected",
        requestId: requestId,
        requestType: "Service Request",
      };

      this.inventoryService.adminAction(declineRequest).subscribe(
        (response) => {
          window.location.reload();
          // this.snackBar.open("Request Declined", "OK");
          this.getServiceRequestData();
        },
        (err) => {
          alertModalWithoutConfirm("error", "Failed to delete the request.");
        }
      );
    }
  }

  totalServiceSearchedInv: any;
  searchedServiceInventory = [];
  onSearchServiceInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.totalService,
      searchQuery: this.searchServiceReqQuery,
    };
    if (this.searchQuery === "") {
      this.clearSearch();
    } else {
      this.inventoryService.getServiceRequest(field).subscribe((response) => {
        console.log(response);
        this.searchedServiceInventory = response["data"].records;
        this.serviceRequest = this.searchedServiceInventory;
        this.totalServiceSearchedInv = response["data"].totalCounts;
        this.totalService = this.totalServiceSearchedInv;
      });
    }
  }

  clearServiceReqSearch() {
    this.searchServiceReqQuery = "";
    this.searchedServiceInventory = [];
    this.serviceRequest = [];
    this.currentPageNume = 1;
    this.getServiceRequestData();
  }

  onScroll() {
    if (this.showServiceRequestTable) {
      console.log(
        "Scrolled! Current service Request Length:",
        this.serviceRequest.length
      );
      const totalLoaded = this.serviceRequest.length;
      if (totalLoaded >= this.totalService) return;
      this.currentPageNume++;
      this.getServiceRequestData();
    }

    if (this.showPendingRequest) {
      const totalLoaded = this.pendingReq.length;
      if (totalLoaded >= this.totalPending) return;
      this.currentPageNume++;
      this.onFilterPendingRequest(
        this.selectedRequestType,
        this.currentPageNume,
        this.currentPendingLimit
      );
    }

    if (this.showApprovedRequest) {
      const totalLoaded = this.approveInv.length;
      if (totalLoaded >= this.totalApproved) return;
      this.currentPageNume++;
      this.onFilterApprovedRequest(
        this.selectedRequestType,
        this.currentPageNume,
        this.currentApprovedLimit
      );
    }

    if (this.showDeclinedRequest) {
      const totalLoaded = this.approveInv.length;
      if (totalLoaded >= this.totalApproved) return;
      this.currentPageNume++;
      this.onFilterDeclinedRequest(
        this.selectedRequestType,
        this.currentPageNume,
        this.currentDeclinedLimit
      );
    }

    if (this.showForwardedReqTable) {
      const totalLoaded = this.forwardedReq.length;
      if (totalLoaded >= this.totalForwarded) return;
      this.currentPageNume++;
      this.filterForwardReq(
        this.selectedRequestType,
        this.currentPageNume,
        this.currentLimit
      );
    }
  }

  acceptRequest(requestId: any) {
    console.log(this.currentRequestType, "RequestType");
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "Service Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/service-request?filter=Approved Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      console.log("called");
      alertModalWithoutConfirm("success", "Request Approved!");
      // this.snackBar.open("Request Accepted", "OK");
      this.serviceRequest = this.serviceRequest.filter(
        (req) => req.requestId !== requestId
      );
      this.totalService = Math.max(0, this.totalService - 1);
    });
  }

  async declineRequest(requestId: any) {
    const userConfirmed = await alertModalDecline(
      "Are you sure you want to decline this request?"
    );

    // Proceed only if the user confirms
    if (userConfirmed) {
      const declineRequest = {
        action: "Rejected",
        requestId: requestId,
        requestType: "Service Request",
        redirectUrl: `${environment.redirectUrl}#/inventory/service-request?filter=Declined Request`,
      };

      this.inventoryService.adminAction(declineRequest).subscribe(
        (response) => {
          console.log("Request declined successfully");
          // this.snackBar.open("Request Declined", "OK");

          this.serviceRequest = this.serviceRequest.filter(
            (req) => req.requestId !== requestId
          );
          this.totalService = Math.max(0, this.totalService - 1);
        },
        (err) => {
          console.error("Error while declining the request", err);
          alertModalWithoutConfirm("error", "Failed to decline the request.");
        }
      );
    } else {
      console.log("User cancelled the decline action");
    }
  }

  async deleteServiceRequest(requestId: any, approverId: any) {
    const userConfirmed = await alertModalDelete(
      "Are you sure you want to delete this request?"
    );
    if (userConfirmed) {
      const declineRequest = {
        approverId: approverId,
        requestId: requestId,
        requestType: "Service Request",
      };

      this.inventoryService.deleteAction(declineRequest).subscribe(
        (response) => {
          // this.snackBar.open("Request Declined", "OK");
          window.location.reload();

          this.getServiceRequestData();
        },
        (err) => {
          alertModalWithoutConfirm("error", "Failed to delete the request.");
        }
      );
    }
  }

  navigateWithFilter(filterType: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { filter: filterType },
      queryParamsHandling: "merge",
    });
  }
}
